import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';
import { GetResponse, Installation } from '../../models';
import { mockEndpointDelay } from '@vi-iot/client';
import {
  MockedAccessList,
  MockedInstallation,
  MockInstallationSummary,
  MockMaterialDetailsResponse,
  MockMaterialGatewayNameResponse,
} from './equipment.mocks';
import {
  AccessList,
  ActiveErrorResponse,
  DataWithCursorResponse,
  EquipmentLiteDetail,
  GatewayMaterialDetailsResponse,
  InstallationSummary,
  MaterialDetailsResponse,
  ResetGatewayResponse,
} from './equipment.model';
import { DashboardApiMocks } from '../dashboard/dashboard.mocks';
import { TranslateService } from '@ngx-translate/core';

@Injectable()
export class EquipmentMockApi {
  constructor(private translateService: TranslateService) {}

  getInstallationAccessList(id: number): Observable<GetResponse<AccessList>> {
    return of(new MockedAccessList(id).mock()).pipe(delay(mockEndpointDelay));
  }

  getInstallation(_id: number): Observable<GetResponse<Installation>> {
    return of(new MockedInstallation().mock()).pipe(delay(mockEndpointDelay));
  }

  getMaterialGatewayName(gatewaySerial: string): Observable<GatewayMaterialDetailsResponse> {
    return of(new MockMaterialGatewayNameResponse().mock(gatewaySerial)).pipe(
      delay(mockEndpointDelay)
    );
  }

  getMaterialDetails(boilerSerial: string): Observable<MaterialDetailsResponse> {
    return of(new MockMaterialDetailsResponse().mock(boilerSerial)).pipe(delay(mockEndpointDelay));
  }

  equipmentSummary(boilerSerial: string): Observable<InstallationSummary> {
    return of(new MockInstallationSummary().mock(boilerSerial)).pipe(delay(mockEndpointDelay));
  }

  listActiveError(
    installationId: number
  ): Observable<DataWithCursorResponse<ActiveErrorResponse[]>> {
    // Display error header basing on errorCode
    const smartNotes = DashboardApiMocks.getSmartNotes(installationId).map((note) => {
      return {
        ...note,
        content: {
          ...note.content,
          errorDescription: this.translateService.instant(
            `TI_F_${note.content.errorCode.split('.')[1]}`
          ),
        },
      };
    });

    return of({ cursor: { next: '' }, data: smartNotes });
  }
  validateBoilerSerial(): Observable<void> {
    return of(null);
  }

  refreshDeviceList(
    _installationId: number,
    _gatewaySerial: string
  ): Observable<ResetGatewayResponse> {
    return of(null).pipe(delay(mockEndpointDelay));
  }

  liteDetail(_serial): Observable<EquipmentLiteDetail> {
    return of(null);
  }
}
